<template>
  <ValidationProvider :name="name" :rules="rules" v-slot="{ errors }" class="field__item" mode="fuseboxEager">
    <div class="field__item--label">
    </div>
    <slot name="input">
      <div :class="[{'input__group--red': errors.length > 0}, {'required': required}]" @click="focusThis()" class="field__item--input flex">
      <span ref="label" class="dynamic-label" :class="{ 'focused' : shouldHaveFocused}">{{ label }}</span>
      <input :readonly="readonly" ref="input" autocomplete="off" :id="name" :name="name" :type="type"
           v-bind:value="value" @focusout="$emit('focusoutFunction')"
           @focus="focused = true" @blur="focused = false" @input="$emit('input', $event.target.value)"/>
      </div>
    </slot>
    <span :class="{'form__notice--active': errors.length > 0}" class="form__notice text--red">{{ errors[0] }}</span>
    <span class="form__helper form__helper--active" v-if="hasSlotData"><slot
      name="helper-text"></slot></span>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'Field',
  props: {
    label: String,
    readonly: {
      type: Boolean,
      default: false
    },
    name: String,
    rules: [String, Object],
    type: String,
    value: {},
    classes: {},
    required: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      focused: false
    }
  },
  computed: {
    hasSlotData () {
      return !!this.$slots['helper-text']
    },
    shouldHaveFocused () {
      if (this.focused) {
        return true
      }
      return this.value === null ? false : !!(typeof this.value !== 'undefined' && this.value.length)
    }
  },
  methods: {
    changeValue: function (event) {
      this.$emit('input', event.target.value)
    },
    focusThis: function () {
      this.$refs.input.focus()
    }
  }
}
</script>
